import axios from 'axios'
import global from '@/global/variable.js'

// 获取预约列表
export function getManOrderList(data) {
  const url = global.requestUrl + '/personOrder/list?limit=' + data.limit + '&page=' + data.page 
              + '&startDate=' + data.start + '&endDate=' + data.end 
              + '&name=' + data.name + '&gate=' + data.gate + '&status=' + data.status
  return axios.get(url)
}

// 创建人员预约信息
export function createManOrderOne(data) {
  const url = global.requestUrl + '/personOrder/create'
  return axios.post(url, data, {headers: {
    'Content-Type':'multipart/form-data'
  }})
}

// 人员预约审核
export function updateManOrderOne(data) {
  const url = global.requestUrl + '/personOrder/check/' + data.id + '?yesOrNo=' + data.yesOrNo + '&rejectReason=' + data.rejectReason
  return axios.get(url)
}

// 获取预约列表
export function getCarOrderList(data) {
  const url = global.requestUrl + '/carOrderRecord/list?limit=' + data.limit + '&page=' + data.page 
              + '&startDate=' + data.start + '&endDate=' + data.end 
              + '&plateNumber=' + data.plateNumber + '&status=' + data.status
  return axios.get(url)
}

// 创建货车预约信息
export function createCarOrderOne(data) {
  const url = global.requestUrl + '/carOrderRecord/create'
  return axios.post(url, data)
}

// 货车预约审核
export function updateCarOrderOne(data) {
  const url = global.requestUrl + '/carOrderRecord/check/' + data.id + '?yesOrNo=' + data.yesOrNo + '&rejectReason=' + data.rejectReason
  return axios.get(url)
}

// 获取预约列表
export function getTruckOrderList(data) {
  const url = global.requestUrl + '/truckOrder/list?limit=' + data.limit + '&page=' + data.page 
              + '&startDate=' + data.start + '&endDate=' + data.end 
              + '&plateNumber=' + data.plateNumber + '&status=' + data.status
  return axios.get(url)
}

// 创建货车预约信息
export function createTruckOrderOne(data) {
  const url = global.requestUrl + '/truckOrder/create'
  return axios.post(url, data)
}

// 货车预约审核
export function updateTruckOrderOne(data) {
  const url = global.requestUrl + '/truckOrder/check/' + data.id + '?yesOrNo=' + data.yesOrNo + '&rejectReason=' + data.rejectReason
  return axios.get(url)
}
